import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Tooltip } from "react-tooltip";
import { actionCreators } from "../redux/packagesSalesSaga";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

const ExcludeMembership = () => {
  const dispatch = useDispatch();
  const excludeMembership = useSelector(
    (state) => state.packagesSales.selectedFilters.exclude_membership
  );
  const tooltipId = "excludeMembershipTooltip";

  return (
    <>
      <div className="select-box-no-width" style={{ marginRight: "20px" }}>
        <p
          data-tooltip-id={tooltipId}
          data-tooltip-content="When toggled ON, all Membership packages will be excluded."
        >
          Exclude Membership
        </p>
        <ToggleableButton
          isActive={excludeMembership}
          isRadio
          title="exclude-membership"
          onClick={(data) => dispatch(actionCreators.updateExcludeMembership(data))}
        />
      </div>
      <Tooltip id={tooltipId} className="toggleTooltip" />
    </>
  );
};

export default ExcludeMembership;
